var _path, _path2, _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroSectionTamperProofMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 808,
    viewBox: "0 0 375 808",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1913_34418)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1913_34418)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 56H375V768C375 768 302.214 808 187.5 808C72.7865 808 0 768 0 768V56Z",
    fill: "#6D2FEC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1913_34418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 56,
    width: 375,
    height: 752
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56H375V768C375 768 302.214 808 187.5 808C72.7865 808 0 768 0 768V56Z",
    fill: "#6D2FEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1913_34418)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1913_34418)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1913_34418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.8152 635.474L-151.537 748.084",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.542 635.474L-18.1426 748.084V913.452",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.8477 748.084L113.013 635.473L150.266 635.473L90.377 747.848V913.925H-17.8477V748.084Z",
    fill: "url(#paint0_linear_1913_34418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.266 635.474L89.6152 748.084V910.14",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.992 635.474V748.084L187.994 912.032",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.719 635.474L286.369 748.084L286.372 916.764",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.443 635.473L394.127 748.084L394.132 912.742",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.829 748.084L263.442 635.474L226.188 635.474L286.548 748.084L286.549 915.108H393.833L393.829 748.084Z",
    fill: "url(#paint1_linear_1913_34418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.168 635.474L527.519 748.084",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-151.529 748.084H527.528",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-113.613 729.222H489.615",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.2656 710.641H452.267",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.3613 691.779H414.342",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.447266 672.917H376.428",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9023 654.336L339.082 654.336",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.528 635.474H-151.529V704.081H527.528V635.474Z",
    fill: "url(#paint2_linear_1913_34418)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1913_34418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.176 195.598L527.528 84.3345",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.449 195.598L394.136 84.3345V47.4026",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.725 195.598L286.376 84.3345V50.6751",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 195.598V84.3345V48.5714",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.274 195.598L89.623 84.3345V50.4413",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55 195.598L-18.1348 84.3345V54.415",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.823 195.598L-151.529 84.3345",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.528 84.3345L-151.529 84.3346",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.614 102.971H-113.615",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.267 121.329H-76.2656",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.353 139.966H-38.3516",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.439 158.603H-0.4375",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.09 176.961H36.9102",
    stroke: "white",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-151.528 197L527.529 197V47.4025L-151.528 47.4025V197Z",
    fill: "url(#paint3_linear_1913_34418)"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 56,
    fill: "#F7F2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1913_34418",
    x1: 126.216,
    y1: 637.839,
    x2: 123.61,
    y2: 778.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793BF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1913_34418",
    x1: 251.653,
    y1: 627.43,
    x2: 318.745,
    y2: 785.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793BF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1913_34418",
    x1: 187.999,
    y1: 639.732,
    x2: 187.999,
    y2: 704.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245192,
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D2FEC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1913_34418",
    x1: 188.001,
    y1: 187.715,
    x2: 188.001,
    y2: 47.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211538,
    stopColor: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6D2FEC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D2FEC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1913_34418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 808,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1913_34418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 752,
    fill: "white",
    transform: "translate(0 56)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1913_34418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 223,
    fill: "white",
    transform: "translate(0 635)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1913_34418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 282,
    fill: "white",
    transform: "translate(-152 635)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1913_34418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 151,
    fill: "white",
    transform: "translate(-152 46)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionTamperProofMobile);
export default __webpack_public_path__ + "static/media/heroSectionTamperProofMobile.081f99802baae4dc448df6ca1bcb2748.svg";
export { ForwardRef as ReactComponent };